export class Permissoes {
  static PESQUISA_PERFIL_ACESSO: Permissoes = new Permissoes('PESQUISA_PERFIL_ACESSO');
  static CADASTRO_PERFIL_ACESSO: Permissoes = new Permissoes('CADASTRO_PERFIL_ACESSO');


  static COORDENADA_DINAMICA_ROTEIRIZADOR: Permissoes = new Permissoes('COORDENADA_DINAMICA_ROTEIRIZADOR');
  static TIPO_DE_VEICULO: Permissoes = new Permissoes('TIPO_DE_VEICULO');
  static RAMO_DE_ATIVIDADE: Permissoes = new Permissoes('RAMO_DE_ATIVIDADE');



  private innerValor;

  constructor(valor) {
    this.innerValor = valor;
  }

  getValor() {
    return this.innerValor;
  }
}
